module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_9005.f9849235.png";